const CHECK_SVG =
    '<div class="qm-check-overlay"><svg class="qm-check-svg" viewBox="0 0 52 52">' +
    '<circle class="cmc" cx="26" cy="26" r="25"/>' +
    '<path class="cmk" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg></div>';

const TOTAL_Q = 11;
const CALC_IDX = 12;
const RESULT_IDX = 13;
const CALC_MS = 2500;
const ADVANCE_MS = 800;
const CLOSE_MS = 350;

const initDesignQuiz = () => {
    const modal = document.getElementById("quizModal");
    const openBtn = document.getElementById("openQuizBtn");
    if (!modal || !openBtn) return;

    const closeBtn = document.getElementById("qmClose");
    const backdrop = document.getElementById("quizBackdrop");
    const startBtn = document.getElementById("qmStart");
    const backBtn = document.getElementById("qmBackBtn");
    const backWrap = document.getElementById("qmBack");
    const progFill = document.getElementById("qmProgressFill");
    const resultsEl = document.getElementById("qmResults");
    const pages = Array.from(modal.querySelectorAll(".qm-page"));
    if (!pages.length) return;

    let cur = 0;
    let locked = false;
    const scores = {};

    const setProgress = () => {
        if (cur === 0) {
            progFill.style.width = "0%";
        } else if (cur >= CALC_IDX) {
            progFill.style.width = "100%";
        } else {
            progFill.style.width = `${Math.round(((cur - 1) / TOTAL_Q) * 100)}%`;
        }
    };

    const goTo = (idx) => {
        if (locked || idx < 0 || idx >= pages.length) return;
        locked = true;
        pages[cur].classList.remove("active");
        cur = idx;
        pages[cur].classList.add("active");
        setProgress();
        backWrap.classList.toggle("visible", cur > 0 && cur < CALC_IDX);
        modal.scrollTop = 0;
        locked = false;
    };

    const getWinner = () => {
        const tally = {};
        Object.values(scores).forEach((style) => {
            tally[style] = (tally[style] || 0) + 1;
        });
        let best = "transitional";
        let max = 0;
        Object.entries(tally).forEach(([style, count]) => {
            if (count > max) {
                max = count;
                best = style;
            }
        });
        return best;
    };

    const restart = () => {
        Object.keys(scores).forEach((key) => delete scores[key]);
        pages.forEach((page) => {
            page.classList.remove("active");
            const check = page.querySelector(".qm-check-overlay");
            if (check) check.remove();
            page.querySelectorAll(".selected").forEach((el) => el.classList.remove("selected"));
        });
        cur = 0;
        pages[0].classList.add("active");
        locked = false;
        setProgress();
        backWrap.classList.remove("visible");
        resultsEl.innerHTML = "";
        modal.scrollTop = 0;
    };

    const buildResults = () => {
        const tpl = document.getElementById(`qmr-${getWinner()}`);
        if (!tpl) return;
        resultsEl.innerHTML = "";
        resultsEl.appendChild(tpl.content.cloneNode(true));
        const retake = resultsEl.querySelector("[data-retake]");
        if (retake) retake.addEventListener("click", restart);
    };

    const advance = () => {
        const next = cur + 1;
        if (next >= pages.length) return;
        if (next === CALC_IDX) {
            goTo(CALC_IDX);
            window.setTimeout(() => {
                buildResults();
                goTo(RESULT_IDX);
            }, CALC_MS);
        } else {
            goTo(next);
        }
    };

    const openModal = () => {
        modal.classList.add("open");
        document.body.style.overflow = "hidden";
        window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => modal.classList.add("visible"));
        });
    };

    const closeModal = () => {
        modal.classList.remove("visible");
        window.setTimeout(() => {
            modal.classList.remove("open");
            document.body.style.overflow = "";
        }, CLOSE_MS);
    };

    openBtn.addEventListener("click", (event) => {
        event.preventDefault();
        openModal();
    });
    if (closeBtn) closeBtn.addEventListener("click", closeModal);
    if (backdrop) backdrop.addEventListener("click", closeModal);
    if (startBtn) startBtn.addEventListener("click", advance);

    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && modal.classList.contains("open")) closeModal();
    });

    if (backBtn) {
        backBtn.addEventListener("click", () => {
            if (cur <= 0 || locked) return;
            let prev = cur - 1;
            if (prev === CALC_IDX) prev -= 1;
            goTo(prev);
        });
    }

    modal.addEventListener("click", (event) => {
        const card = event.target.closest("[data-score]");
        if (!card || locked || card.hasAttribute("data-retake")) return;
        const score = card.dataset.score;
        if (!score) return;

        scores[cur] = score;

        const grid = card.closest(".qm-img-grid, .qm-text-grid");
        if (grid) {
            grid.querySelectorAll("[data-score]").forEach((el) => el.classList.remove("selected"));
        }
        card.classList.add("selected");

        const page = pages[cur];
        if (!page.querySelector(".qm-check-overlay")) {
            page.style.position = "relative";
            page.insertAdjacentHTML("beforeend", CHECK_SVG);
        }

        window.setTimeout(advance, ADVANCE_MS);
    });

    setProgress();
};

initDesignQuiz();
